import React, { useState, useRef, useEffect } from "react";
import CommonInputContainer from "./CommonInputContainer";

function CommonSearchableDropdownInput({
  options = [],
  value,
  placeholder,
  onChange,
  label,
  error,
  className,
  search,
  onSearchChange,
  loading,
  onOpen,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    handleToggle();
    const label = options.find((option) => option.code === value)?.label || "";
    if (onChange) {
      // onSearchChange(label);
      onChange(value);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [error, value]);

  useEffect(() => {
    onOpen?.(isOpen);
  }, [isOpen]);

  // console.log({
  //   val: options.find((option) => option.code === value)?.label,
  //   options,
  // });

  return (
    <CommonInputContainer
      label={label}
      className={className}
      error={error && !value}
    >
      <div ref={dropdownRef} className="relative w-full">
        <div
          //   onClick={handleToggle}
          className={`w-full h-12 items-center px-4 border ${
            error && !value ? "border-red-600" : "border-[#DBDBDB]"
          } bg-white rounded-lg placeholder:text-[#A4B1C1] focus:outline-none flex justify-between cursor-pointer`}
        >
          <input
            type="text"
            className="flex flex-1"
            placeholder={placeholder}
            value={
              isFocused
                ? search
                : options.find((option) => option.code === value)?.label || ""
            }
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={() => {
              handleToggle();
              setIsFocused(true);
            }}
            onBlur={() => setIsFocused(false)}
          />
          {/* <span className={`${value ? "text-black" : "text-[#A4B1C1]"}`}>
            {value || placeholder}
          </span> */}
          {loading ? <div className="primaryLoader"></div> : <></>}
          {/* <img
            src="/IconChevronDown.svg"
            alt=""
            className={`w-3 transition-all object-contain ${
              isOpen ? "rotate-180" : ""
            }`}
          /> */}
        </div>
        {isOpen && options?.length ? (
          <ul className="absolute w-full mt-2 bg-white border border-[#DBDBDB] rounded-lg shadow-md z-10 max-h-[200px] overflow-scroll scroll-hide">
            {options?.map((option, index) => (
              <li
                key={index}
                onClick={() => handleOptionClick(option?.code)}
                className="px-4 py-2 hover:bg-[#F0F4F8] cursor-pointer"
              >
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-gray-900">
                    {option?.label}
                  </span>

                  {option?.description ? (
                    <span className="text-xs text-gray-500 leading-snug">
                      {option.description}
                    </span>
                  ) : null}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <></>
        )}
      </div>
    </CommonInputContainer>
  );
}

export default CommonSearchableDropdownInput;
